var React = require('react');

function QuotationMarks (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 18.445C0 6.30826 6.35036 0 18.5606 0V8.7395C13.6752 8.7395 10.4509 10.7753 9.28028 14.5745H18.5606V33.013H0V18.445ZM23.4394 18.445C23.4394 6.30826 29.7898 0 42 0V8.7395C37.1146 8.7395 33.8904 10.7753 32.7197 14.5745H42V33.013H23.4394V18.445Z","fill":"#E44331"}));
}

QuotationMarks.defaultProps = {"width":"42","height":"34","viewBox":"0 0 42 34","fill":"none"};

module.exports = QuotationMarks;

QuotationMarks.default = QuotationMarks;
